/**
 * Version shown on the chat landing greeting ("Sales Assistant AI vX.Y")
 * and the link behind "See what's new".
 *
 * On each release: bump APP_VERSION and point WHATS_NEW_URL at the video
 * for that release. Leave WHATS_NEW_URL empty to hide the link.
 * Planned: v3.0 once entity resolution lands.
 */

export const APP_VERSION = '2.5';

export const WHATS_NEW_URL = 'https://dfhinc-my.sharepoint.com/:v:/g/personal/vkripka_designsforhealth_com/IQBFoMRbenw4QbAYPSeSnBvzAWfTFfqmVDIamtZPGgEFfCA?e=Vrd9qc&nav=eyJyZWZlcnJhbEluZm8iOnsicmVmZXJyYWxBcHAiOiJTdHJlYW1XZWJBcHAiLCJyZWZlcnJhbFZpZXciOiJTaGFyZURpYWxvZy1MaW5rIiwicmVmZXJyYWxBcHBQbGF0Zm9ybSI6IldlYiIsInJlZmVycmFsTW9kZSI6InZpZXcifX0%3D';
